import React, { useLayoutEffect } from 'react';
import useTemplateNavigationGuard, { BlockierteNavigation } from '../../hooks/useTemplateNavigationGuard';

interface Props {
  geaendert: boolean;
  freigabeRef: React.MutableRefObject<() => void>;
  /** RITA-1547: eigene Rückfrage statt der Browserfrage für Navigationen innerhalb des PRM. */
  onBlockiert?: BlockierteNavigation;
}

/** Der Aufrufer haengt den Waechter bei einem Adresswechsel neu ein, nicht den Editor. */
export default function Verlassensschutz(props: Props) {
  const { geaendert, freigabeRef, onBlockiert } = props;
  const freigeben = useTemplateNavigationGuard(geaendert, onBlockiert);
  useLayoutEffect(() => {
    freigabeRef.current = freigeben;
  }, [freigabeRef, freigeben]);
  return null;
}
